import { FiMail } from 'react-icons/fi';

import Input from '@components/Input';

import { FieldRendererProps } from '../types';

const EmailField = ({ field, disabled }: FieldRendererProps) => (
  <Input
    name={field.name}
    type="email"
    placeholder={field.placeholder || field.label}
    icon={FiMail}
    disabled={disabled}
    required={field.is_required}
    inputMode="email"
    autoComplete="email"
  />
);

export default EmailField;
